// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import AdditionalParameters from '../controls/AdditionalParameters'
import _ from 'lodash'
import Select from '../controls/Select'
import type { OptionType } from '../types'
import LabeledWrapper from './LabeledWrapper'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding-bottom: 10px;
`
const SelectWrapper: StyledComponent<Object, any, any> = styled.div`
  width: 250px;
`

type Props = {|
  value: number,
  onChange: Function
|}

const t = {
  link_label: 'Частота показов ВКонтакте',
  label: 'Лимит показов на каждое объявление'
}

const VALID_LIMIT_VALUES = [1, 2, 3, 5, 10, 15, 20]

export default class VkShowsLimitInfo extends Component<Props> {
  render() {
    return (
      <Wrapper>
        <AdditionalParameters link={t.link_label}>
          <LabeledWrapper label={t.label} twoLines>
            <SelectWrapper className="t-VkShowsLimitSelect">
              <Select
                value={this.props.value}
                options={this.options()}
                onChange={(val) => this.props.onChange(val)}
              />
            </SelectWrapper>
          </LabeledWrapper>
        </AdditionalParameters>
      </Wrapper>
    )
  }

  options(): Array<OptionType> {
    return _.map(VALID_LIMIT_VALUES, (limit) => {
      return { id: limit, name: limit.toString() }
    })
  }
}
